import React from 'react';

import { NavigationItem } from './NavigationItem';
import { HoverConsumer } from '../../custom-cursor';

import * as felaRules from './SectionNavigation.rules';
import { useFelaEnhanced } from '@ackee/fela';

type SectionNavigationProps = {
    sections: Record<string, any>;
    itemsVisible?: boolean;
};


const SectionNavigation = ({ sections, itemsVisible = false }: SectionNavigationProps) => {
    const [activeItemId, setActiveItemId] = React.useState(0);
    const { styles } = useFelaEnhanced(felaRules);

    const sectionRefs = React.useMemo(() => Object.values(sections).map(item => item.ref), [sections]);
    const sectionTitles = React.useMemo(() => Object.values(sections).map(item => item.title), [sections]);
    const sectionIds = React.useMemo(() => Object.values(sections).map(item => item.id), [sections]);

    React.useEffect(() => {
        const sectionElements = sectionRefs.map(item => item.current);

        const observeCallback = (entries: IntersectionObserverEntry[]) => {
            entries.forEach(entry => {
                if (entry.intersectionRatio > 0) {
                    const entryIndex = sectionElements.indexOf(entry.target as HTMLElement);
                    setActiveItemId(entryIndex);
                }
            });
        };

        const getRootMargin = () => {
            const windowHalf = window.innerHeight / 2;

            return `0px 0px -${windowHalf}px 0px`;
        };

        const options = {
            rootMargin: getRootMargin(),
        };

        const observer = new IntersectionObserver(entries => observeCallback(entries), options);

        sectionElements.forEach(section => section && observer.observe(section));
    }, [sectionRefs]);

    const lastIndex = React.useMemo(() => sectionRefs.length - 1, [sectionRefs]);

    return (
        <div className={styles.container}>
            <HoverConsumer>
                {render =>
                    sectionRefs.map((item, index) => (
                        <NavigationItem
                            // @ts-expect-error 
                            context={render.context}
                            setContext={render.setContext}
                            reference={item}
                            title={sectionTitles[index]}
                            active={index === activeItemId}
                            key={sectionIds[index]}
                            isLast={index === lastIndex}
                            itemsVisible={itemsVisible}
                        />
                    ))
                }
            </HoverConsumer>
        </div>
    );
};

export default SectionNavigation;
